import { Helmet } from "react-helmet";
import {
  CHARTERING_AND_OPERATION_SERVICES,
  CHARTERING_AND_OPERATION_SERVICES_TEXT,
  CREW_MANNING_SERVICES,
  CREW_MANNING_SERVICES_TEXT,
  MARINE_AND_TECHNICAL_ADVICE,
  MARINE_AND_TECHNICAL_ADVICE_TEXT,
  OUR_SERVICES,
  OUT_SERVICES_TEXT,
  SHIP_BROKING_SERVICES,
  SHIP_BROKING_SERVICES_TEXT,
  SHIP_CONSTRUCTION_SUPERVISION,
  SHIP_CONSTRUCTION_SUPERVISION_TEXT,
  SHIP_MANAGEMENT,
  SHIP_MANAGEMENT_TEXT,
  SHIP_PURCHASE_INSPECTION,
  SHIP_PURCHASE_INSPECTION_TEXT,
  SHIP_REPAIR_SUPERVISION,
  SHIP_REPAIR_SUPERVISION_TEXT,
} from "../../constants/translations";
import PageHeader from "../../hybrids/PageHeader/PageHeader";
const ServicesPage = () => {
  const isMobile = window.innerWidth <= 768;
  const splittedShipManagement = isMobile
    ? SHIP_MANAGEMENT
    : SHIP_MANAGEMENT.split(" ");
  return (
    <>
      <Helmet>
        <title>{OUR_SERVICES}</title>
      </Helmet>
      <div className="services-page-wrapper">
        <PageHeader
          customClassName={"services-header"}
          text={OUT_SERVICES_TEXT}
          title={OUR_SERVICES}
        />
        <section className="services-wrapper">
          <div className="content-wrapper mm-width">
            <div className="service-wrapper">
              <h2 className="service-title">
                {!isMobile ? (
                  <>
                    {splittedShipManagement[0]}
                    <br />
                    {splittedShipManagement[1]}
                  </>
                ) : (
                  splittedShipManagement
                )}
              </h2>
              <p className="service-text">{SHIP_MANAGEMENT_TEXT}</p>
            </div>
            <div className="service-wrapper">
              <h2 className="service-title">{SHIP_CONSTRUCTION_SUPERVISION}</h2>
              <p className="service-text">
                {SHIP_CONSTRUCTION_SUPERVISION_TEXT}
              </p>
            </div>
            <div className="service-wrapper">
              <h2 className="service-title">{MARINE_AND_TECHNICAL_ADVICE}</h2>
              <p className="service-text">{MARINE_AND_TECHNICAL_ADVICE_TEXT}</p>
            </div>
            <div className="service-wrapper">
              <h2 className="service-title">{SHIP_PURCHASE_INSPECTION}</h2>
              <p className="service-text">{SHIP_PURCHASE_INSPECTION_TEXT}</p>
            </div>
            <div className="service-wrapper">
              <h2 className="service-title">{SHIP_BROKING_SERVICES}</h2>
              <p className="service-text">{SHIP_BROKING_SERVICES_TEXT}</p>
            </div>
            <div className="service-wrapper">
              <h2 className="service-title">{SHIP_REPAIR_SUPERVISION}</h2>
              <p className="service-text">{SHIP_REPAIR_SUPERVISION_TEXT}</p>
            </div>
            <div className="service-wrapper">
              <h2 className="service-title">
                {CHARTERING_AND_OPERATION_SERVICES}
              </h2>
              <p className="service-text">
                {CHARTERING_AND_OPERATION_SERVICES_TEXT}
              </p>
            </div>
            <div className="service-wrapper">
              <h2 className="service-title">{CREW_MANNING_SERVICES}</h2>
              <p className="service-text">{CREW_MANNING_SERVICES_TEXT}</p>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default ServicesPage;
